.composite-input {
  --text-area-max-height: 240px;

  padding: var(--rc-theme-spacing-xs);
  border: 1px solid var(--rc-theme-color-border-default);
  border-radius: var(--rc-theme-border-radius-lg);

  &:focus-within {
    border-color: var(--rc-theme-color-primary-default);
  }

  .file-input[type='file'] {
    display: none;
  }

  .text-area {
    max-height: var(--text-area-max-height);
    padding: 0;
    overflow-y: auto;
    transition: none;
  }
}

.field:focus,
.field:focus-visible,
.text-area:focus,
.text-area:focus-visible {
  box-shadow: none;
  outline: none;
}
